const originalRequest = require('../../node_modules/arcdynamic-request/index.js');
import { backendServicesUrl } from '../consts/env';
import { isSessionRefusal } from './sessionRefusal';

// Sessions expire after 60 idle minutes. A tab left open past that gets
// refusals from the gateway; reload once so Root finds no user and shows Login.
let reloadingForSession = false;

function isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

function isDeletedValue(val) {
    if (!val) return false;
    const clean = String(val).trim().toLowerCase();
    if (clean === 'n' || clean === '0' || clean === 'false' || clean === '0000-00-00 00:00:00' || clean === '1970-01-01 00:00:00') {
        return false;
    }
    return true;
}

function isRestoreValue(val) {
    if (!val) return true;
    const clean = String(val).trim().toLowerCase();
    return clean === 'n' || clean === '0' || clean === 'false' || clean === '0000-00-00 00:00:00' || clean === '1970-01-01 00:00:00';
}

function normalizeRequestDeleted(obj) {
    if (!obj) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(normalizeRequestDeleted);
    }

    if (isPlainObject(obj)) {
        const newObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (key === 'DELETED') {
                    const val = obj[key];
                    if (isRestoreValue(val)) {
                        newObj[key] = null;
                    } else if (isDeletedValue(val) && obj['DELETED_AT']) {
                        newObj[key] = obj['DELETED_AT'];
                    } else if (val === 'y' || val === true) {
                        newObj[key] = '1';
                    } else {
                        newObj[key] = val;
                    }
                } else if (key === 'DELETED_AT') {
                    // Skip copying DELETED_AT to the outgoing request payload
                } else {
                    newObj[key] = normalizeRequestDeleted(obj[key]);
                }
            }
        }
        return newObj;
    }

    return obj;
}

function normalizeResponseDeleted(obj) {
    if (!obj) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(normalizeResponseDeleted);
    }

    if (isPlainObject(obj)) {
        const newObj = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (key === 'DELETED') {
                    const val = obj[key];
                    if (isDeletedValue(val)) {
                        newObj[key] = '1';
                        if (val !== '1' && val !== 'y' && val !== true) {
                            newObj['DELETED_AT'] = val;
                        }
                    } else {
                        newObj[key] = null;
                        newObj['DELETED_AT'] = null;
                    }
                } else {
                    newObj[key] = normalizeResponseDeleted(obj[key]);
                }
            }
        }
        return newObj;
    }

    return obj;
}

export default function shimmedRequest(url, req, opts) {
    let targetUrl = url;

    // Check if the request is destined for the remote Arc API
    const arcApiUrl = window.arc && window.arc.path && window.arc.path.api;
    if (arcApiUrl && url === arcApiUrl) {
        targetUrl = backendServicesUrl;
    }

    const normalizedReq = normalizeRequestDeleted(req);

    return originalRequest(targetUrl, normalizedReq, opts).then(res => {
        if (!reloadingForSession && isSessionRefusal(res)) {
            reloadingForSession = true;
            window.location.reload();
        }
        return normalizeResponseDeleted(res);
    });
}
